import {ManagerHeader} from '../mixins/header'
import Tutorial from '../mixins/tutorial'

export default {
  name: 'main-frame',
  components: { 'manager-header': ManagerHeader, Tutorial },
  computed: {
    sidebarState () {
      return this.AppState.Sidebar
        ? 'sidebar-open'
        : 'sidebar-close'
    }
  },
  data () {
    return {
      tutorial: true
    }
  }
}
